module.exports = __webpack_public_path__ + "img/legal_representative.0812ff11.svg";